/**
 * @desc OA同步用户数据接口(新增)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<defs.UserDataRequest>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/user/add',
    data,
  });
}

export function mock(
  data: Array<defs.UserDataRequest>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/user/add',
    data,
  });
}
